import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import {
	connectTeamsGlobalGroupsResource,
	routingOnboardingFinishedResource,
} from '@jira/router-resources__service-desk-routing/src/routingSetupStatusResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { projectSettingsServicedeskWorkforceRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskWorkforceRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { WorkforceOptimizationSettingsSkeleton } from '@jira/spa-apps__project-settings-service-desk-workforce-optimization/src/WorkforceOptimizationSettingsSkeleton.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { expVal } from '@atlassian/jira-feature-experiments';
import { workforceOptimizationSettingsPageEntryPoint } from './ui/service-desk-workforce-optimization/workforceOptimizationSettingsPageEntryPoint.tsx';

const isWorkforceAemEnabled = (): boolean =>
	fg('jsm_workforce_use_aem') ? isFeatureEnabled('jira-service-management', 'jsm-workforce') : true;

const getConnectTeamsGlobalGroupsResources = () =>
	expVal('global_group_search_wfo', 'isEnabled', false) ? [connectTeamsGlobalGroupsResource] : [];

export const projectSettingsServicedeskWorkforceRouteEntry: ReturnType<typeof createEntry> =
	createEntry(projectSettingsServicedeskWorkforceRoute, () => ({
		group: 'project-settings-servicedesk',
		ufoName: 'jsm-workforce-optimization-settings',
		entryPoint: () => {
			if (!fg('jsm_workforce_settings_rename_route')) {
				return notFoundPageEntrypoint;
			}

			if (!isWorkforceAemEnabled()) {
				return undefined;
			}

			return workforceOptimizationSettingsPageEntryPoint;
		},
		layout: serviceProjectLayout,
		skeleton: fg('jsm-routing-release-2') ? WorkforceOptimizationSettingsSkeleton : undefined,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			getConsolidationStateResource(),
			routingOnboardingFinishedResource,
			...getConnectTeamsGlobalGroupsResources(),
		],
		forPaint: [LazyAtlassianNavigation],
		perfMetricKey: 'jsm-workforce-optimization-settings',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}));
